let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lNnZI")).then(() => parcelRequire('kU0T7'));